export default __webpack_public_path__ + "static/media/ambasadorp1big.3b072b1e.jpg";